'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './record-votes.routes';

export class RecordVotesComponent {
  constructor(Auth, DTOptionsBuilder, dialogs, $uibModal, $window, $stateParams, VotingsService, User,
              SettingsService, VoterGroupsService) {
    'ngInject';

    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.ballotId;
    this.$uibModal = $uibModal;

    this.VotingsService = VotingsService;
    this.VoterGroupsService = VoterGroupsService;

    this.voterResponseMap = {};
    this.voterVotedMap = {};
    this.voterProxyVoteMap = {};
    this.voterTypeMap = {};

    SettingsService.getByName({name: 'client'}, settings => {
      this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
      this.useSuite = settings.data.useSuite;

      this.weightVisible = settings.data.weightVisible;
      this.hasBuildingNo = settings.data.buildingNoVisible;

      let sepPos = 4;

      if (this.weightVisible) sepPos++;
      if (this.hasBuildingNo) sepPos++;

      this.dtOptions = DTOptionsBuilder
        .newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'])
        .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
        .withOption('columnDefs', [{ className: "sep-responses", "targets": [ sepPos ] },])
        .withOption('buttons', [
        {
          text: 'Export',
          action: _ => {

            let headers = [
              "Lot#",
              "Address",
              "Voter",
              "Voted By",
              "Proxy Vote"
            ];

            this.ballot.responses.forEach(response => headers.push(response));

            let data = [];
            let row = [];
            this.users.forEach(property => {

              let lotNo = property.lotNo;
              let street = property.address.street;
              let voter = (property.eVoting && property.eVoting.voter) ? this.getComposedName(property.eVoting.voter) : "-";
              let votedBy = "-"

              if (this.voterTypeMap[property._id] == 'evote')
                votedBy = "E-Vote";

              if (this.voterTypeMap[property._id] == 'paper')
                votedBy = "Paper";

              let proxyVote = "";

              if (this.voterProxyVoteMap[property._id])
                proxyVote = "Yes";

              row = [].concat(lotNo, street, voter, votedBy, proxyVote);

              this.ballot.responses.forEach(response => {
                row.push((this.voterResponseMap[property._id][response]) ? "x" : "");
              });

              data.push(row);

            });

            this.$uibModal.open({
              animation: true,
              component: 'datatableViewer',
              resolve: {
                config: function () {
                  return {
                    data,
                    settings: {
                      "columns": headers
                    },
                    name: "Ballot Responses"
                  }
                }
              },
              size: 'lg'
            });
          }
        }
      ]);

      VotingsService.get({id: this.voteId}, vote => {
          this.vote = vote;
          this.ballot = this.vote.ballots.find(ballot => ballot._id == this.ballotId);

          let VG_DATA_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
          VoterGroupsService[VG_DATA_METHOD]({id: this.vote.voterGroup._id}, vg => {

            this.users = vg.properties;

            this.users.forEach(property => {
              this.voterResponseMap[property._id] = {};

              let vote = this.vote.votes.find(v => v.ballot == this.ballotId && v.property == property._id);

              this.voterVotedMap[property._id] = !!vote;
              this.voterProxyVoteMap[property._id] = vote && vote.voteByProxy;

              if (vote)
                this.voterTypeMap[property._id] = vote.type;

              this.ballot.responses.forEach(r => {
                this.voterResponseMap[property._id][r] = (vote && vote.responses.includes(r));
              })
            })
          });
        });

      }, err => {
        console.log("Could not retrieve users.")
      });

    this.back = _ => $window.history.back();
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += " (" + contact.company + ")";
      }
    }

    return composedName;
  }

  upsertVote(property) {

    let responses = this.ballot.responses.filter(r => !!this.voterResponseMap[property._id][r]);

    let voterId = (property.eVoting && property.eVoting.voter) ? property.eVoting.voter._id : "0";
    this.VotingsService.upsertNonSecretVote({id: this.voteId, voterId: voterId, propertyId: property._id}, {
      ballotId: this.ballotId,
      responses: responses,
      type: "paper",
      weight: property.eVoting.weight || 1,
      voteByProxy: this.voterProxyVoteMap[property._id]
    }, _=> {}, err => {
      console.log(err);
    });
  }

}

export default angular.module('conduu.recordVotes', [uiRouter])
  .config(routes)
  .component('recordVotes', {
    template: require('./record-votes.html'),
    controller: RecordVotesComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/ballot/record-votes/record-votes.component.js